
// 郵便番号取得API
// http://zipcloud.ibsnet.co.jp/doc/api

import * as zipModels from '@/class/models/typed/zipcloud';

const url = 'https://zipcloud.ibsnet.co.jp/api/search';

export const getAddressData = async (zipcode: string): Promise<zipModels.IZipCloud> => {
  const res = await fetch(`${url}?zipcode=${zipcode}`, { method: 'GET' });
  const result: zipModels.IZipCloud = await res.json();
  result.success = result.status === 200;
  return result;
};
